﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Abonnement",
  "change": "Skift",
  "currency": "USD",
  "save": "Spar",
  "save17Percent": "<strong>Spar {{percent}} %</strong> med et årligt abonnement",
  "save17PercentNoBold": "Spar {{percent}} %",
  "yearly": "Årligt",
  "monthly": "Månedligt",
  "Lifetime": "For livstid",
  "PerMonth": "Pr. måned",
  "PerYear": "Pr. år",
  "Free": "Gratis",
  "optional": "valgfri",
  "trialLengthTrial": "<0>{{ trialLength }}</0>dages prøveperiode",
  "viewAllPlans": "Se alle abonnementer",
  "myBoardmaker": "My Boardmaker",
  "canada": "Canada",
  "unitedStates": "USA",
  "oneMomentPlease": "Et øjeblik ...",
  "software": "Software",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Fuldfør",
  "loadingRegions": "Indlæser tilgængelige regioner",
  "loadingPartners": "Indlæser tilgængelige partnere",
  "supportedPeripherals": "Understøttede eksterne enheder",
  "pleaseWait": "Vent ...",
  "minimum": "Mindst",
  "recommended": "Anbefalet",
  "browser": "Internetbrowser",
  "tobiiDynavoxEyeTrackers": "Tobii Dynavoxs Eye Trackers",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "brug for hjælp til at vælge",
  "or": "eller",
  "advantages": "Fordele",
  "visitPartnerSite": "Besøg partnerwebsted",
  "recentOrders": "Seneste ordrer",
  "current": "aktuel",
  "orLater": "eller senere",
  "customerSupport": "kundesupport",
  "proratedAmount": "Forholdsmæssigt beløb",
  "community": {
    "community": "Fællesskab",
    "getStartedNow": "Kom godt i gang nu!"
  },
  "personal": "Personligt abonnement",
  "professional": "Professionelt abonnement",
  "planCard": {
    "noCCRequired": "Der kræves intet kreditkort",
    "cCOnly": "Kun kreditkort",
    "cCOrPO": "Kreditkort eller købsordre",
    "myPlan": "Mit abonnement",
    "currentPlan": "Nuværende abonnement",
    "downgradeNotice": "Ændring træder i kraft, når det nuværende abonnement udløber.",
    "upgradeNotice": "Ændring stræder straks i kraft."
  },
  "selectedPlanSummary": {
    "summary": "Sammenfatning",
    "change": "$t(change)",
    "subtotal": "Subtotal"
  },
  "action": {
    "joinToday": "Meld dig til i dag!",
    "finish": "Udfør",
    "subscribe": "Abonnér",
    "resubscribe": "Abonnér på ny",
    "requestAQuote": "Stil spørgsmål vedr. abonnement",
    "try": "Prøv",
    "startTrial": "Start prøveperiode",
    "buyNow": "Køb nu",
    "tryIt": "Prøv det",
    "tryItFree": "Prøv det gratis i 30 dage!",
    "free": "gratis",
    "getStarted": "Kom godt i gang",
    "forTrialDays": "i <1>{{trialLength}}</1> dage",
    "comparePlans": "Sammenlign produkter",
    "hideComparisons": "Skjul sammenligningsoversigt",
    "learnMore": "Lær mere",
    "start": "Start",
    "next": "Næste",
    "edit": "Redigér",
    "cancel": "Annullér",
    "imTaxExempt": "Momsfritagelse",
    "submit": "Indsend",
    "print": "Print",
    "backToPaymentDetails": "Tilbage til betalingsoplysninger",
    "close": "Luk",
    "back": "Bagside",
    "continue": "Fortsæt",
    "uploading": "Overfører",
    "delete": "Slet",
    "update": "Opdatér",
    "generatingInvoice": "Opretter faktura",
    "proceed": "Fortsæt",
    "modify": "Redigér",
    "yes": "Ja",
    "signUp": "Tilmeld",
    "downloads": "Downloads"
  },
  "status": {
    "loading": "Indlæser ...",
    "creatingAccount": "Opretter konto ...",
    "submitting": "Sender ...",
    "submittingPayment": "Sender betaling ...",
    "submittingRequest": "Sender anmodning ..."
  },
  "planComparison": {
    "label": "Hvad er fordelene ved de enkelte abonnementer?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Sammenligning af funktioner",
    "subheader": "Verdens mest populære løsning til oprettelse af løbende symbolbaseret kommunikation og visuelle støtter!"
  },
  "account": {
    "email": "E-mailadresse",
    "accountFoundTitle": "Konto eksisterer",
    "accountFoundMessage": "Der findes allerede en konto med samme e-mailadresse. Vil du logge ind med den konto eller bruge en anden e-mailadresse og oprette en ny konto?",
    "signedOutElsewhereTitle": "Du er blevet logget ud",
    "signedOutElsewhereMessage": "Du blev logget ud i en anden fane. Log ind igen for at fortsætte, eller afvis dette for at fortsætte uden en konto.",
    "signedOutElsewhereDismiss": "Fortsæt browsing",
    "federatedEmailTitle": "Organisations-e-mail genkendt",
    "federatedEmailMessage": "Denne e-mailadresse bruger din organisations login. Log ind for at få adgang til Boardmaker via din organisation, eller brug en anden e-mailadresse til at oprette en ny konto.",
    "federatedEmailUseDifferent": "Brug en anden e-mailadresse",
    "logIn": "Log ind",
    "logOut": "Log af",
    "loggingIn": "Logger ind …",
    "loggingOut": "Logger af ...",
    "verifying": "Bekræfter ...",
    "loggingInMessage": "Du bliver logget ind ...",
    "createAccount": "Opret konto",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Har allerede en ",
    "login2": "Tobii Dynavox-",
    "login3": "konto",
    "loginPrompt": "Har du allerede en <1>Tobii Dynavox-konto</1>? <3>Log ind</3>",
    "cancelSubscription": "Annullér abonnement",
    "areYouSure": "Vil du vælge dette abonnement? Der sker følgende, hvis du fortsætter:",
    "cancelSubscriptionProcess": "Annullér abonnementsprocessen (din nuværende status går tabt)",
    "changeToCommunityPlan": "Skift konto til et fællesskabsabonnement",
    "onceYouveCompletedYourProfile": "Hvis du beslutter at opgradere dit abonnement, kan du altid gøre det i afsnittet Min konto, når du har udfyldt din profil.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Henter brugeroplysninger"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Udfyld oplysningerne nedenfor, og en kontoadministrator vil kontakte dig senere.",
    "fillOutDetailsBelowLicense": "Udfyld oplysningerne nedenfor, og en salgskonsulent vil kontakte dig senere."
  },
  "forms": {
    "confirmEmail": "Bekræft e-mailadresse",
    "billingDetails": "Faktureringsoplysninger",
    "paymentType": "Betalingsform",
    "creditCardType": "Betalingsform",
    "creditCard": "Kreditkort",
    "purchaseOrder": "Købsordre",
    "cardNumber": "Kortnummer",
    "expirationDate": "Udløbsdato",
    "cardholderName": "Kortholdernavn",
    "cardSecurityCode": "Sikkerhedskode på kort",
    "securityCode": "Sikkerhedskode",
    "organizationName": "Organisationsnavn",
    "accountsPayableEmail": "Mail til fakturamodtagelse",
    "firstName": "Fornavn",
    "lastName": "Efternavn",
    "addressLine": "Adresselinje 1",
    "addressLine2": "Adresselinje 2",
    "country": "Land",
    "language": "Sprog",
    "city": "By",
    "stateProvinceRegion": "Region/kommune",
    "zipPostalCode": "Postnummer",
    "month": "Måned",
    "year": "År",
    "optional": "valgfri",
    "username": "Brugernavn",
    "name": "Navn",
    "phoneNumber": "Telefonnummer",
    "phone": "Telefon",
    "email": "E-mailadresse",
    "url": "Webadresse",
    "selectYourCountry": "Vælg land",
    "selectYourState": "Vælg region",
    "selectYourProvinceTerritory": "Vælg kommune",
    "selectYourTerm": "Vælg periode",
    "1year": "1 år",
    "2years": "2 år",
    "3years": "3 år",
    "4years": "4 år",
    "5years": "5 år",
    "instructorLogins": "Antal log-in til undervisere",
    "studentLogins": "Antal log-in til elever",
    "term": "Periode",
    "tradeIn": "Er du berettiget til en rabat?",
    "legacyVersions": "Har du tidligere versioner af Boardmaker, der kan gives i bytte for en rabat på udgiften til myBoardmaker?",
    "selectAResponse": "Vælg svar",
    "yes": "Ja",
    "no": "Nej",
    "notSure": "Ikke sikker",
    "password": "Adgangskode",
    "confirmPassword": "Bekræft adgangskode",
    "additionalInformationOrQuestions": "Flere oplysninger eller spørgsmål",
    "countryNotSupported": "---",
    "uploadDocument": "Overfør dokument",
    "chooseFile": "Vælg fil",
    "paymentMethod": "Betalingsmåde",
    "purchaseOrdersAreOnlyProcessed": "Købsordrer behandles først, når din ordre er sendt, og kan derfor altid ændres før afsendelsen.",
    "PONumber": "Købsordrenr.",
    "PONotes": "Organisationsbemærkninger",
    "iVerifyThatImAuthorized": "Jeg bekræfter, at jeg er autoriseret til at afsende købsordren.",
    "submissionSuccessful": "Afsendelse udført!",
    "thankYourForYourRequest": "Tak for din anmodning! Du vil blive kontaktet af en kontoadministrator lidt senere.",
    "ccExpDateFormat": "MM/YYYY",
    "numberOfLicenses": "Antal licenser",
    "pleaseEnterYourName": "Indtast navnet præcist, som det står på kortet",
    "needHelpFindingSecurityCode": "Brug for hjælp til at finde sikkerhedskoden på kortet"
  },
  "validation": {
    "required": "Obligatorisk",
    "invalidEmail": "Ugyldig e-mailadresse",
    "emailsMustMatch": "E-mailadresser skal matche",
    "passwordsMustMatch": "Adgangskoder skal matche",
    "errorOccurred": "Der opstod en fejl ved afsendelse af formularen",
    "tryAgain": "Prøv igen. Kontakt support, hvis problemet fortsætter.",
    "errorOccurredPDF": "Der opstod en fejl ved indlæsning af faktura i pdf-format",
    "password": {
      "minLength": "Adgangskoden skal indeholde mindst otte tegn",
      "tooShort": "For kort",
      "checking": "Kontrollerer ..."
    },
    "invalidCardNumber": "Ugyldigt kortnummer",
    "invalidCardType": "Ugyldig korttype",
    "invalidExpirationDate": "Ugyldig udløbsdato",
    "invalidSecurityCode": "Ugyldig sikkerhedskode",
    "securityCodeNumericWarning": "Sikkerhedskoden må kun indeholde tal",
    "invalidUsernameWarning": "Ugyldigt brugernavn. Må kun indeholde bogstaver og tal.",
    "usernameMaxLengthWarning": "Brugernavn kan maksimalt indeholde 60 tegn",
    "badZip": "Det angivne postnummer er ikke gyldigt for det valgte land.",
    "badPostalCode": "Det angivne postnummer er ikke gyldigt for den valgte region eller kommune.",
    "canadianAddressNeedsCad": "Canadiske faktureringsadresser faktureres i canadiske dollar. Vælg flaget øverst på siden, og vælg derefter Canada for at fortsætte.",
    "USZipCode": "Indtast et amerikansk postnummer",
    "CAZipCode": "Indtast et canadisk postnummer."
  },
  "invoice": {
    "communityHeader": "Intet kreditkort. Kun gratis adgang til myBoardmaker Community. Bevar dine data og status, hvis du beslutter at opgradere til et betalingsabonnement. Hvad venter du på?",
    "trialHeader": "Ingen begrænsninger. Intet kreditkort. Bevar dine data og status, hvis du beslutter at konvertere din prøveperiode til et betalingsabonnement. Hvad venter du på?",
    "plan": "Abonnement",
    "term": "Periode",
    "price": "Pris",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Betalingsoplysninger",
    "endingWith": "Ender på",
    "expires": "Udløber",
    "orderSummary": "Bestillingsoversigt",
    "orderDate": "Ordredato",
    "orderNumber": "Ordrenummer",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Moms",
    "total": "I alt",
    "aConfirmationEmail": "En mail med ordrebekræftelse er sendt til",
    "printOrderSummary": "Print ordreoversigt",
    "recurringPaymentDisclaimer": "Din ordre indeholder en <strong>fast betaling</strong> på <3>{{amount}}</3>, der fornys den <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Vi opkræver <strong>{{amount}}</strong> den <strong>{{date}}</strong>, når dit nye abonnement starter.",
    "PODisclaimer": "Dit abonnement er nu aktivt og klart til brug. Din betaling skal være os i hænde inden for <strong>30 dage</strong> for at undgå afbrydelse af tjenesten. Hvis betalingen ikke modtages senest <4>{{date, LL}}</4>, konverteres din konto til en gratis fællesskabskonto, indtil du har betalt beløbet.",
    "purchaseOrderNumber": "Købsordrenr.",
    "orgNotes": "Organisationsbemærkninger",
    "pleaseSendACopyOfYourInvoice": "Send din betaling og en kopi af fakturaen til:",
    "ifYourPurchaseOrdersReady": "Du kan overføre købsordren nu, hvis den er klar.",
    "supportedFileTypes": "Understøttede filtyper: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Vi sender en mail til <1>{{email}}</1>, når den tid kommer, som minder dig om forfaldsdatoen for næste betaling.",
    "uploadSuccessful": "Overførsel udført!",
    "yourAccountWillContinue": "Tak for din købsordre. Du skal regne med en ekspeditionstid på op til 14 dage ved fornyelse af abonnement. Du modtager derefter en mail, der bekræfter fornyelsen, sammen med din faktura.",
    "billing": "Faktureringsadresse",
    "payment": "Betalingsmåde",
    "ifYourPurchaseOrderIsReady": "Du kan overføre købsordren nu, hvis den er klar.",
    "PODisclaimer1": "Dit abonnement er nu aktivt og klart til brug.",
    "PODisclaimer2": "Betaling skal modtages inden for 30 dage, ellers konverteres din konto automatisk til en gratis fællesskabskonto.",
    "POStartsLaterDisclaimer": "Vi sender din faktura den <strong>{{date}}</strong>, når dit nye abonnement starter. Betalingen forfalder inden for 30 dage fra den dato."
  },
  "legal": {
    "privacyPolicy": "Politik om beskyttelse af personlige oplysninger",
    "studentPolicy": "Retningslinjer for elevdata",
    "termsAndConditions": "Vilkår og betingelser",
    "termsOfService": "Vilkår for tjeneste",
    "tdTermsAndConditions": "Jeg er indforstået med <1>$t(legal.termsAndConditions) for Tobii Dynavox</1>",
    "contactUs": "Kontakt os"
  },
  "errors": {
    "error": "Fejl",
    "loadingPlans": "Indlæser abonnementer",
    "sorry": "Undskyld ... det var ikke dig ... det var os",
    "somethingWentWrong": "Noget gik galt hos os. Vi har registreret fejlen og opfordrer dig til at bruge <1>{{link}}</1>, hvis problemet opstår igen.",
    "tryGoingBack": "Prøv at gå tilbage eller <1>{{link}}</1>",
    "downloadList": "Kunne ikke indlæse downloadlisten."
  },
  "404": {
    "sorry": "Beklager ... Vi kunne ikke finde siden",
    "oldLink": "Det kan være et gammelt link, eller siden er flyttet.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Start din gratis prøveperiode nu!",
    "startYourFreeTrial": "Start din gratis prøveperiode",
    "todayWhichIncludesAccessForThirtyDays": " i dag med adgang i 30 dage!"
  },
  "navigation": {
    "bmoRedirect": "Omdirigerer dig til myBoardmaker ..."
  },
  "expired": {
    "expiredTrialText": "Vi håber, at du har nydt den 30 dages ubegrænsede prøveversion. Din prøveperiode er konverteret til et gratis fællesskabsabonnement, og alle dine data og din status er gemt. Du skal blot opgradere til et månedsabonnement eller et årsabonnement for at få adgang til premium funktionerne, som var tilgængelige under prøveperioden.",
    "dataAndProgress": "* Du kan kun få adgang til data og status for disse premium funktioner, når du tegner et komplet betalingsabonnement."
  },
  "currencySelector": {
    "header": "Vælg land og sprog",
    "disclaimer": {
      "USD": "Vælg USA, hvis dit land ikke findes på listen"
    }
  },
  "taxExempt": {
    "us&ca": "Kun USA og Canada",
    "taxExemptionProgram": "Brug formularen til at fremsende dokumentation for din momsfritagelse. Vi kontakter dig pr. mail inden for 3 hverdage for at bekræfte din momsfritagelsesstatus. Du kan afgive en ordre uden moms, når du har modtaget mailen med bekræftelsen. Du opkræves moms, der ikke kan refunderes, hvis du afgiver din ordre, før du har modtaget bekræftelsen pr. mail.",
    "taxExemptionProgramExisting": "Brug formularen til at fremsende dokumentation for din momsfritagelse. Vi kontakter dig pr. mail inden for 3 hverdage for at bekræfte din momsfritagelsesstatus. Fremtidige køb og fornyelse af abonnement pålægges ikke moms, når du har modtaget mailen med godkendelsen. Moms betalt på køb forud for modtagelsen af mailen med bekræftelse på momsfritagelsen refunderes ikke.",
    "yourSubmissionWasSuccessfulNew": "Afsendelse udført. Vores medarbejdere gennemgår dokumentationen, og du modtager inden for 3 hverdage en underretningsmail, der bekræfter, at din anmodning er behandlet. Du kan færdiggøre din ordre uden moms, når momsfritagelsen er godkendt. Vi har i mellemtiden oprettet en gratis fællesskabskonto til dig, så du kan begynde at udforske alle funktionerne i myBoardmaker.",
    "yourSubmissionWasSuccessfulExisting": "Afsendelse udført. Vores medarbejdere gennemgår dokumentationen, og du modtager inden for 3 hverdage en underretningsmail, der bekræfter, at din anmodning er behandlet. Du kan gennemføre din næste betaling uden moms, når momsfritagelsen er godkendt."
  },
  "modify": {
    "contactCustomerSupport": "Kontakt <1>{{supportLink}}</1> for at ændre dit abonnement",
    "billingDetails": "Redigér faktureringsoplysninger",
    "paymentModalHeader": "Opdatering udført!",
    "paymentModalBody": "Ændringerne fremgår af næste faktura.",
    "thankYou": "Tak for din betaling!",
    "daysRemaining": "dage tilbage",
    "dueDisclaimer": "Hvis betalingen ikke modtages inden 30 dage før datoen for fornyelse, konverteres din konto automatisk til en gratis fællesskabskonto, indtil du har betalt beløbet.",
    "lateDisclaimer": "Betal hele beløbet for at undgå afbrydelse af abonnementet. Hvis betalingen ikke modtages, konverteres din konto automatisk til en gratis fællesskabskonto, indtil du har betalt beløbet.",
    "nextPaymentDueIn": "Næste betaling forfalder om",
    "days": "dage",
    "paymentIs": "Betalingsfristen er overskredet med",
    "daysPastDue": "dage",
    "recurringPaymentDisclaimer": "Din <1>planOrOrder</1> indeholder en <strong>fast betaling</strong> på <4>{{amount}}</4>, der fornys den <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Dit abonnement indeholder en <strong>fast betaling</strong>, der fornys den <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Du kan indsende din købsordre på en af måderne beskrevet nedenfor. Kontakt vores kundesupport for at aktivere dit abonnement igen.",
    "yourAccountHasBeenConverted": "Din betalingskonto konverteres til en gratis fællesskabskonto",
    "balanceDueIn": "Saldo forfalder om",
    "subscriptionExpiresIn": "Abonnement udløber om",
    "paymentPastDue": "Forfalden betaling",
    "autoRenewal": "Automatisk abonnementsfornyelse",
    "turnAutoRenewOff": {
      "header": "Deaktivér automatisk abonnementsfornyelse",
      "areYouSure": "Vil du annullere automatisk abonnementsfornyelse? Der sker følgende, hvis du fortsætter:",
      "points": [
        "Annullér dit betalingsabonnement ved udgangen af indeværende faktureringsperiode.",
        "Konvertér din konto til et gratis fællesskabsabonnement ved udgangen af indeværende faktureringsperiode.",
        "Du har adgang til dit indhold efter konverteringen, og du kan altid oprette et nyt abonnement for at få adgang til premium funktionerne, der følger med et betalingsabonnementet. ",
        "Aktivér automatisk abonnementsfornyelse på ny, hvis du ændrer mening før udløbet af dit nuværende abonnement."
      ],
      "footer": "Vil du deaktivere automatisk abonnementsfornyelse?"
    },
    "turnAutoRenewOn": {
      "header": "Aktivér automatisk abonnementsfornyelse",
      "areYouSure": "Funktioner i automatisk abonnementsfornyelse:",
      "points": [
        "Dit abonnement fornys automatisk ved udløbet af indeværende abonnementsperiode.",
        "Problemfri betaling via din gemte betalingsmåde.",
        "Vi sender dig en kvittering for alle abonnementsfornyelser pr. mail.",
        "Du kan altid ændre indstillingerne for dit abonnement i oplysningerne under Mit abonnement.",
        "Hvis du skifter mening? Deaktivér automatisk abonnementsfornyelse før udgangen af den sidste dag i den indeværende abonnementsperiode, og du bliver ikke opkrævet."
      ],
      "footer": "Vil du aktivere automatisk abonnementsfornyelse?"
    },
    "on": "Til",
    "off": "Fra",
    "pending": "afventer",
    "plan": "Abonnement",
    "term": "Periode",
    "effective": "Effektiv",
    "subscription": "Abonnement",
    "downgradeWarning": {
      "title": "Nedgradér abonnement",
      "prompt": "Vil du vælge dette abonnement? Der sker følgende, hvis du fortsætter:",
      "planChange": "Nedgradér dit abonnement fra professionelt abonnement til personligt abonnement ved udløbet af indeværende faktureringsperiode",
      "termChange": "Nedgradér din abonnementsperiode fra årligt abonnement til månedligt abonnement ved udløbet af indeværende faktureringsperiode",
      "changeNote": "Ændringerne fremgår af næste faktura.",
      "termChangeMultiToYearly": "Nedgradér dit flerårige abonnement til et årligt abonnement ved udløbet af indeværende faktureringsperiode",
      "termChangeMultiToMonthly": "Nedgradér dit flerårige abonnement til et månedligt abonnement ved udløbet af nuværende faktureringsperiode"
    },
    "futureAmendmentThankYou": "Ændringerne træder i kraft ved udløbet af indeværende faktureringsperiode. Du får en faktura, når ændringerne er trådt i kraft for din konto. Ring til <1>kundesupport</1>, hvis du vil annullere en afventende ændring.",
    "futureAmendmentDisclaimer": "Dit nuværende <1>{{planName}}</1>-abonnement udløber den <3>{{startEndDate}}</3>. Dit nye <5>{{selectedPlanName}}</5>-abonnement starter den <7>{{startEndDate}}</7> og fornys automatisk den <9>{{term}}</9>.",
    "modificationPending": "Ændring af abonnement afventer",
    "paymentDeclined": "Betalingen af fornyelsen af dit abonnement blev afvist. Redigér betalingsmåde senest den <1>{{date}}</1> for at undgå annullering af dit abonnement.",
    "continueSubscription": "Dit abonnement udløber den <1>{{ date1 }}</1>. Hvis du ønsker at fortsætte abonnementet i yderligere {{term}},, skal du aktivere automatisk abonnementsfornyelse senest den <5>{{ date2 }}</5>, og vi trækker betalingen den følgende dag.",
    "discontinuedRatePlan": "Dit nuværende abonnement findes ikke længere. Vælg en anden mulighed.",
    "cancelYourSubscription": "Hvis du vil annullere dit abonnement og modtage fuld refundering, skal du kontakte <1>{{supportLink}}</1> senest <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Redigér abonnement",
    "cancelCardText": "Du kan til enhver tid annullere dit abonnement. Men vi vil meget gerne have, at du bliver.",
    "cancelConfirmTitle": "Er du sikker på, at du vil annullere dit abonnement?",
    "cancelConfirmIntro": "Dit nuværende abonnement forbliver aktivt indtil <strong>{{date}}</strong>. Når dit abonnement udløber:",
    "cancelConsequences": [
      "Du mister adgangen til premium-funktioner.",
      "Du går glip af eksklusive fordele, som er tilgængelige med dit abonnement.",
      "Fordelene ved dit abonnement ophører, når dit nuværende abonnement udløber."
    ],
    "keepSubscription": "Behold mit abonnement",
    "confirmCancel": "Nej, jeg vil annullere",
    "cancelledTitle": "Dit abonnement er blevet annulleret!",
    "cancelledBody": "Dit abonnement er blevet annulleret. Du har ikke adgang til din premium-konto efter {{date}}.",
    "cancelledFarewell": "Vi er kede af at se dig gå! Du er altid velkommen tilbage.",
    "done": "Færdig",
    "cancelledNotice": "Dit nuværende <strong>{{planName}}</strong>-abonnement udløber den <strong>{{date}}</strong>. Forny dit abonnement for fortsat at nyde godt af vores premium-funktioner.",
    "resubscribedNotice": "Dit nye <strong>{{planName}}</strong>-abonnement starter den <strong>{{date}}</strong>, når dit nuværende udløber."
  },
  "tdAccount": {
    "title": "Tobii Dynavox-konto",
    "header": "Hvad er en Tobii Dynavox konto med Single Sign on - adgang (SSO)?",
    "body": "Den eneste konto, som du skal bruge til at logge ind på alle vores websteder eller apps, er din Tobii Dynavox SSO-konto, der består af en e-mailadresse og en adgangskode. Ud over forbedret sikkerhed giver SSO-kontoen dig også hurtigere og nemmere adgang til dit indhold på alle Tobii Dynavox-tjenester.",
    "haveA": "Har du en",
    "tobiiDynavoxAccount": "Tobii Dynavox-konto?"
  },
  "redirectPageTitle": {
    "homePage": "Startside",
    "profileCreation": "Oprettelse af profil"
  },
  "download": {
    "downloadBoardmaker": "Download Boardmaker",
    "downloadBoardmakerStudentCenter": "Download Boardmaker Student Center",
    "downloadOtherVersions": "Download andre versioner",
    "downloadBoardmakerStudio": "Download Boardmaker Studio",
    "licenseKey": "Licensnøgle",
    "download": "Download",
    "licenseHelper": "Licensadministration",
    "discontinued": "Udgået <1>{{discontinueDate}}</1>. Se <3>systemkrav</3>.",
    "mainFeatures": "Hovedfunktioner",
    "compatibility": "Kompatibilitet",
    "improvements": "Forbedringer",
    "bugFixes": "Fejlrettelser",
    "version": "Version",
    "discontinuedSupport": "Support ikke længere tilgængelig",
    "releaseDate": "Udgivet  {{date}}",
    "discontinuedDate": "Udgået {{date}}",
    "boardmakerSummary": "Vælg knappen nedenfor for at downloade den seneste version af Boardmaker Editor, der bruges til oprettelse og redigering af aktiviteter.  Installationsprogrammet kan bruges sammen med alle kontotyper og understøttede sprog.",
    "studentCenterSummary": "Vælg knappen nedenfor for at downloade den seneste version af Boardmaker Student Center, der bruges til afspille Boardmaker-aktiviteter. Installationsprogrammet kan bruges sammen med alle kontotyper og understøttede sprog.",
    "boardmakerIntro": "Boardmaker 7 Editor er det bedste redskab til at hjælpe undervisere, terapeuter og forældre med at oprette, redigere og dele aktiviteter i Boardmaker. Understøt indlæring og kommunikation i klasseværelset, terapilokalet eller hjemmet med er væld af materiale, der kan tilpasses.",
    "studentCenterIntro": "Sammen med visse typer abonnementer til Boardmaker 7  kan lærere tildele aktiviteter til elever i Boardmaker 7 Student Center-appen og følge deres fremskridt.  Elever kan bruge appen hjemme eller i skolen til at udføre deres aktiviteter.",
    "boardmakerStudioIntro": "Boardmaker Studio tillader personer, der hjælper elever med handicap i at oprette og redigere aktiviteter, hvilket hjælper eleverne med at lære at kommunikere ved hjælp af symboler, tekst og syntetisk og indspillet tale.",
    "mobilePlayerIntro": "Sammen med visse typer abonnementer til myBoardmaker  kan lærere tildele aktiviteter til elever i Boardmaker Student Center-appen og følge deres fremskridt.  Elever kan bruge appen hjemme eller i skolen til at udføre deres aktiviteter.",
    "communityStartHeader": ["Få adgang til fællesskab og lager", 0, 0],
    "communityStartBody": [
      "Boardmaker er designet til at arbejde sammen med Boardmakeronline.com, hvor du på en sikker måde kan sikkerhedskopiere dine Boardmaker-filer og få adgang til vores globale fællesskab. Medlemmerne af fællesskabet kan dele deres arbejde og finde nye Boardmaker-aktiviteter hos andre medlemmer. Tilmeld dig, og få en gratis fællesskabskonto for at få adgang!",
      0,
      0
    ],
    "latestMobile": "Få den bedste oplevelse ved at downloade softwaren fra en enhed, der opfylder <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "Systemkrav",
    "viewSystemRequirements": "Se <1>{{guideLink}}</1> med systemkrav.",
    "onThisPage": "På denne side",
    "communityStart": {
      "header": "Få adgang til fællesskab og lager",
      "body": "Boardmaker er designet til at arbejde sammen med myboardmaker.com. Din gratis konto til Boardmaker Community omfatter:",
      "pointOne": "Cloudlager – Sikkerhedskopiér dine personlige Boardmaker-filer, og få adgang til dem overalt!",
      "pointTwo": "Activities-to-Go – Niveauinddelte tematiske læseplaner, der er udskrifts- og brugsklare.",
      "pointThree": "Adgang til vores globale fællesskab – Del dit arbejde, og find nye Boardmaker-aktiviteter hos andre brugere.",
      "footer": "Tilmeld dig din gratis fællesskabskonto, og få adgang!"
    },
    "BoardmakerCompatible": "Enheden er ikke kompatibel med Boardmaker-software.",
    "BoardmakerStudentCenterCompatible": "Enheden er ikke kompatibel med programmet Boardmaker Student Center.",
    "BoardmakerMobile": "Enheden understøtter ikke Boardmaker-applikationer."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "abonnement",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "licens",
      "tolicenseText": "engangskøb",
      "mainText": "Foretrækker du <1>{{ toggleText }}</1> eller <3>{{ helpLink }}</3>?",
      "preferencedText": "Foretrækker du "
    },
    "comparison": {
      "accessTo": "Adgang til følgende ...",
      "title": "Hjælp mig med at vælge",
      "titleDescription": "En hurtig gennemgang af forskellene på et abonnement til myBoardmaker og selve Boardmaker-softwaren.",
      "titles": {
        "investment": "Investering",
        "includedSoftware": "Software medfølger",
        "softwareUpdates": "Softwareopdateringer",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Cloudlager",
        "curriculum": "Læseplan",
        "studentManagement": "Elevadministration"
      },
      "subscription": {
        "header": "Abonnement til myBoardmaker",
        "investment": "Lave startomkostninger, mulighed for årlige eller månedlige betalinger",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Medfølger (2-3 gange årligt)",
        "pcsSymbols": "Alle symboler, herunder nye symboler hver anden uge",
        "cloudStorage": ["Gem aktivitet lokation", "gem medie lokation"],
        "curriculum": [
          "Boardmaker Activities to Go, 10 temaer x 4 enheder hver",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": [
          "Tildel aktiviteter\u00B9",
          "registrér resultater"
        ]
      },
      "license": {
        "header": "Kun software",
        "investment": "Engangskøb af software",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Regelmæssige opgraderinger mod betaling (hvert 2.-3. år)",
        "pcsSymbols": "Alle symboler tilgængelige på tidspunktet for sidste udgivelse (abonnement på PCS kommer snart)",
        "cloudStorage": "Gem aktivitet lokation",
        "curriculum": "Boardmaker Activities to Go, 1 tema x 4 enheder",
        "studentManagement": "Ingen"
      },
      "note": "Brugerne kan styre og tilføje opgavetilskrivninger til individuelle elever i det professionelle abonnement",
      "note2": "Kun Student Center Player kan bruges",
      "note3": "Brugerne kan styre og tilføje opgavetilskrivninger til individuelle elever i det professionelle abonnement",
      "localizationNoteOne": "Apperne til Boardmaker 7 findes på følgende sprog til både abonnementsbrugere og permanente (kun software) brugere",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Engelsk (USA)",
        "Spansk",
        "Tysk",
        "Svensk",
        "Finsk",
        "Russisk",
        "Dansk",
        "Norsk",
        "Fransk",
        "Italiensk",
        "Polsk",
        "Portugisisk"
      ],
      "localizationNoteTwo": "Læseplanen og webstedet myBoardmaker.com findes kun på engelsk."
    }
  },
  "systemRequirements": "Systemkrav",
  "releaseNotes": "Produktbemærkninger ",
  "operatingSystem": {
    "title": "Styresystem",
    "macos": "Mac OS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobil)",
    "windows": "Windows",
    "unknown": "Ukendt"
  },
  "perpetual": {
    "trial": {
      "intro": "Intet kreditkort. Ingen forpligtelser. Bare <1>{{trialLength}}</1> fortløbende dage med ubegrænset adgang til vores seneste Boardmaker-software. Når du har downloadet og installeret softwaren på din computer, kan du i softwaren bede om en aktiveringsnøgle for en prøveperiode på <3>{{trialLength}}</3> dage<5>*</5>.",
      "footnote": "<0>*</0>Prøveperioden starter på dagen, hvor softwaren aktiveres, og løber i <2>{{trialLength}}</2> fortløbende dage.",
      "downloadFootnote": "<0>v{{version}}</0> indeholder de seneste funktioner og rettelser. Se <2>systemkrav</2>."
    },
    "thankyou": {
      "intro": "Find links til download af Boardmaker og din aktiveringsnøgle i mailen med din ordrebekræftelse. Oplysningerne findes også nedenfor. Download og installér Boardmaker på din computer, og aktivér derefter softwaren med din aktiveringsnøgle. Efter aktivering modtager du 1 års gratis opdateringer. <1>Gem aktiveringsnøglen til senere brug.</1>"
    },
    "latest": "Seneste",
    "legacy": "Tidligere versioner"
  },
  "countries": {
    "us": "USA"
  },
  "currencyChange": {
    "header": "Valutaændring",
    "body": "Abonnementer kan ikke betales med valutaen i dit valgte land i øjeblikket. Hvis du fortsætter, ændres valutaen til US-dollars (USD)."
  },
  "partner": {
    "body": "Den valgte partner eller supportudbyder er din primære kontaktperson i alle spørgsmål om alle produkter samt tekniske problemer.",
    "contactUs": "Kontakt kundeservice, ",
    "contactCustomerService": "hvis det angivne land er ukorrekt."
  }
}
